const INDIA = new Set(['india', 'in', 'ind', 'bharat', 'hindustan', 'republic of india']);
/** Countries (names and ISO codes) a form answer is likely to name instead of India. */
const FOREIGN_COUNTRIES = new Set([
    'afghanistan', 'af', 'australia', 'au', 'bahrain', 'bh', 'bangladesh', 'bd', 'bhutan', 'bt',
    'canada', 'ca', 'china', 'cn', 'prc', 'france', 'fr', 'germany', 'de', 'hong kong', 'hk',
    'indonesia', 'id', 'iran', 'ir', 'iraq', 'iq', 'italy', 'it', 'japan', 'jp', 'kazakhstan', 'kz',
    'kenya', 'ke', 'kuwait', 'kw', 'malaysia', 'my', 'maldives', 'mv', 'mauritius', 'mu', 'myanmar',
    'mm', 'nepal', 'np', 'netherlands', 'nl', 'new zealand', 'nz', 'nigeria', 'ng', 'oman', 'om',
    'pakistan', 'pk', 'philippines', 'ph', 'qatar', 'qa', 'russia', 'russian federation', 'ru',
    'saudi arabia', 'ksa', 'sa', 'singapore', 'sg', 'south africa', 'za', 'south korea', 'korea',
    'kr', 'sri lanka', 'lk', 'thailand', 'th', 'uae', 'u a e', 'united arab emirates', 'ae',
    'uk', 'u k', 'united kingdom', 'great britain', 'england', 'gb', 'usa', 'u s a', 'us', 'u s',
    'united states', 'united states of america', 'america', 'vietnam', 'viet nam', 'vn',
]);
/**
 * What stands between an FDFC Tracker entry and an NSDC kit order. Empty means
 * it can be sent.
 *
 * Mirrors NSDC's own validation of `POST /api/public/v1/orders` (recipient
 * name 1-200, line1 1-300, line2 ≤300, city/state 1-120, 6-digit PIN not
 * starting with 0, India only) so a bad row is refused here with a readable
 * reason instead of coming back from NSDC as an opaque "Validation failed".
 * Used by both the dispatch dialog and the backend, so they always agree.
 */
export function trackerFdfcDispatchProblems(e) {
    const problems = [];
    const t = (v) => (v ?? '').trim();
    if (e.dispatch_status === 'dispatched')
        problems.push('Already sent to NSDC');
    if (e.dispatch_status === 'dispatching')
        problems.push('Being sent right now');
    if (e.dispatch_status === 'unknown') {
        problems.push('Previous send got no answer — check NSDC, then Allow resend');
    }
    if (!t(e.full_name))
        problems.push('Name is missing');
    else if (t(e.full_name).length > 200)
        problems.push('Name is longer than 200 characters');
    if (!/^\d{10}$/.test(e.mobile_last10 ?? ''))
        problems.push('Mobile is not a 10-digit number');
    if (!t(e.address_line1))
        problems.push('Address line 1 is missing');
    else if (t(e.address_line1).length > 300)
        problems.push('Address line 1 is longer than 300 characters');
    if (t(e.address_line2).length > 300)
        problems.push('Address line 2 is longer than 300 characters');
    if (!t(e.city))
        problems.push('City is missing');
    else if (t(e.city).length > 120)
        problems.push('City is longer than 120 characters');
    if (!t(e.state))
        problems.push('State is missing');
    else if (t(e.state).length > 120)
        problems.push('State is longer than 120 characters');
    const indianPin = /^[1-9]\d{5}$/.test(t(e.pincode));
    if (!indianPin)
        problems.push('Pincode must be a 6-digit Indian PIN');
    // NSDC is never sent a country (it books every order as India); the PIN
    // routes the parcel. The country field is free text from the form and is
    // often junk, so it only blocks when it clearly names another country —
    // several of which (Singapore, China, Russia, …) also use 6-digit codes that
    // look like an Indian PIN — or when the PIN cannot vouch for India either.
    const country = t(e.country).toLowerCase().replace(/[.\s]+/g, ' ').trim();
    const indian = !country || INDIA.has(country);
    if (!indian && (FOREIGN_COUNTRIES.has(country) || !indianPin)) {
        problems.push(`Country is "${t(e.country)}" — NSDC delivers within India only`);
    }
    return problems;
}
//# sourceMappingURL=tracker-fdfc-dispatch.js.map